var version = {
    "name":      "dativery",
    "buildDateCode": "20260320-114713",
    "buildDate": "Fri Mar 20 2026 11:47:13 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260320-114713",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;